module.exports = __webpack_public_path__ + "assets/7ec8ab914f8637bd335a3ddba72a232f.jpg";